import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Component, Inject, Input, OnDestroy, OnInit } from "@angular/core";

import { OnboardingService } from "src/app/services/onboarding.service";

import { CONTAINER_DATA } from "../marketplace-connections.component";
import { StorageKeyEnum } from '../../../core/StorageKeyEnum';
import { MatSnackBar } from "@angular/material/snack-bar";
import { OnlyAlphaNumericValidator } from "src/app/directives/only-alpha-numeric-validator";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { AccountRegion } from "src/app/core/Constants";
import { LoginModel } from "src/app/models/login.model";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-new-connection",
  templateUrl: "./new-connection.component.html",
  styleUrls: ["../new-connection.scss", "./new-connection.component.scss"],
})
export class NewConnectionComponent implements OnInit,OnDestroy {
  form: FormGroup = new FormGroup({
    name: new FormControl('',[Validators.required,OnlyAlphaNumericValidator]),
    marketPlace: new FormControl('')
  });
  private destroy$ = new Subject<void>();
  @Input() channelType: 'amazon' | 'ebay';
  @Input() isOnBoarding:boolean = false;
  @Input() connectedAccounts;
  amazonMarkets: any;
  duplicateNameValue:boolean=false;
  channelURL = {
    amazon: "https://sellercentral.amazon.com/apps/authorize/consent?application_id=amzn1.sellerapps.app.6f4eb559-2502-4eda-9c38-bab742b7cf8b&state=stateex",
    amazonau:"https://sellercentral.amazon.com.au/apps/authorize/consent?application_id=amzn1.sellerapps.app.6f4eb559-2502-4eda-9c38-bab742b7cf8b&state=stateex",
    amazonUk: "https://sellercentral-europe.amazon.com/apps/authorize/consent?application_id=amzn1.sellerapps.app.6f4eb559-2502-4eda-9c38-bab742b7cf8b&state=stateex",
    ebay: "https://auth.ebay.com/oauth2/authorize?client_id=IsaacHer-NineYard-PRD-9ca833663-a219bc6f&response_type=code&redirect_uri=Isaac_Herskovit-IsaacHer-NineYa-hcpej&scope=https://api.ebay.com/oauth/api_scope https://api.ebay.com/oauth/api_scope/sell.marketing.readonly https://api.ebay.com/oauth/api_scope/sell.marketing https://api.ebay.com/oauth/api_scope/sell.inventory.readonly https://api.ebay.com/oauth/api_scope/sell.inventory https://api.ebay.com/oauth/api_scope/sell.account.readonly https://api.ebay.com/oauth/api_scope/sell.account https://api.ebay.com/oauth/api_scope/sell.fulfillment.readonly https://api.ebay.com/oauth/api_scope/sell.fulfillment https://api.ebay.com/oauth/api_scope/sell.analytics.readonly https://api.ebay.com/oauth/api_scope/sell.finances https://api.ebay.com/oauth/api_scope/sell.payment.dispute https://api.ebay.com/oauth/api_scope/commerce.identity.readonly https://api.ebay.com/oauth/api_scope/commerce.notification.subscription https://api.ebay.com/oauth/api_scope/commerce.notification.subscription.readonly",
  }
  products:any[]=[];
  user:LoginModel;

  constructor(
    private onboardingService: OnboardingService,
    @Inject(CONTAINER_DATA) public componentData: any,
    private snackBar:MatSnackBar
    ) {}

  ngOnInit(): void {
    this.user= JSON.parse(localStorage.getItem("User")) as LoginModel;
    if(this.componentData.channelType !== 'ebay'){
      this.getAmazonAccounts();
    }    
    if (this.componentData.channelType === 'amazon') {
      this.form.get('marketPlace').setValidators(Validators.required);
    }
    this.form.get('name').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      localStorage.setItem(StorageKeyEnum.AccountIntegrationName, value);     
    });

    this.form.get('marketPlace').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      localStorage.setItem(StorageKeyEnum.AccountIntegrationMarketplace, value);
      let marketPlaceValue = this.amazonMarkets.filter((res)=> res.marketplaceid == value);
      localStorage.setItem(StorageKeyEnum.AccountIntegrationMarketplaceRegionalId, marketPlaceValue[0].amazonMarketRegionId);
    });
    this.products=[
      {
        name:"Shipyard",
        fee:"179",
        image:"../../../../assets/images/application-icons/shipyard-icon.svg",
        show:this.user.isShipyard
      },
      {
        name:"Planyard",
        fee:"49",
        image:"../../../../assets/images/application-icons/planyard-icon-v2.svg",
        show:this.user.isPlanYard
      },
      {
        name:"Priceyard",
        fee:"149",
        image:"../../../../assets/images/application-icons/priceyard-icon.svg",
        show:this.user.isPriceYard
      }
    ]
  }

  connectEbay() {
    let channelType=this.componentData.channelType;
    switch (this.componentData.amazonMarketRegionId) {
      case AccountRegion.AmazonUk:
        channelType='amazonUk';
        break;
      case AccountRegion.AmazonAU:
        channelType='amazonau';
        break;
      default:
        channelType
        break;
    }
    window.open(
      this.channelURL[channelType],
      "_self"
    );
  };
  
  getAmazonAccounts() {
    this.onboardingService.amazonMarketsByRegion(this.componentData.amazonMarketRegionId).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.amazonMarkets = res;
    });
  }

  validateName(){
    if(this.componentData.channelType === 'ebay'){
      const name=  this.form.get('name').value;
      if(name){     
        this.onboardingService.CheckDuplicateValue('name',name).pipe(takeUntil(this.destroy$)).subscribe({
          next: (res:boolean) => {
          this.duplicateNameValue=  res;
        },
         error: (err) => {
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: err.error.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
          this.duplicateNameValue= true;   
        }
       });
      }
    }
    }

    
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
